import React, {ReactNode} from "react";
import {OptionDto} from "../../../../core/models/dtos/option.dto";
import {Helpers} from "../../../../core/utilities/helpers";
import {Images} from "../../../../core/utilities/images";
import "./QuestionOptions.scss";

interface IProps {
  options: OptionDto[];
  selectedOptionId?: number;
  correctOptionId?: number;
  callbackOptionClick: (optionId: number) => void;
}

const QuestionOptions = (props: IProps) => {

  const getOptionClass = (option: OptionDto, index: number): string => {
    let className = 'option';
    className += index % 2 ? ' odd' : ' even';

    if (option.text.length > 26) {
      className += ' long';
    }

    if (props.selectedOptionId) {
      if (props.correctOptionId) {
        if (option.id === props.correctOptionId) {
          className += ' correct';
        } else if (option.id === props.selectedOptionId) {
          className += ' fail';
        }
      } else {
        if (option.id === props.selectedOptionId) {
          className += ' selected';
        }
      }
    } else {
      if (option.id === props.correctOptionId) {
        className += ' correct';
      }
    }

    return className;
  }

  const handleOptionClick = (optionId: number): void => {
    if (props.selectedOptionId) return;
    props.callbackOptionClick(optionId);
  }

  const renderOption = (option: OptionDto, index: number): ReactNode => {
    return (
      <div
        key={`option-${option.id}`}
        className="col-12 col-md-6 p-0"
        onClick={() => handleOptionClick(option.id)}
      >
        <div className={getOptionClass(option, index)}>
          <span className="option-letter">{Helpers.getLetterFromIndex(index)}</span>
          <span className="option-text">{option.text}</span>
          <div className="option-icon-placeholder"/>
          <img className="option-icon-correct" src={Images.option_correct} alt="correct"/>
          <img className="option-icon-fail" src={Images.option_fail} alt="fail"/>
        </div>
      </div>
    );
  }

  return (
    <div id="question-options">
      <div className="row mx-0">
        {props.options.map((option, index) => renderOption(option, index))}
      </div>
    </div>
  );
}

export default QuestionOptions;
